const ViewPDF = ({data,length}) => {
   
  return (
            <div className="col-lg-8">
                { length>0 ? ( 
                                <object
                                width="100%"
                                height="900"
                                data={data}
                                type="application/pdf"
                                ></object>) 
                        : 
                            (<div className="alert alert-danger" role="alert">Non è stato caricato nessun PDF </div>)


                }
            </div>
        )
  }
export default ViewPDF